import { render, staticRenderFns } from "./GitHubPanel.vue?vue&type=template&id=baeea878&scoped=true&"
import script from "./GitHubPanel.vue?vue&type=script&lang=js&"
export * from "./GitHubPanel.vue?vue&type=script&lang=js&"
import style0 from "./GitHubPanel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GitHubPanel.vue?vue&type=style&index=1&id=baeea878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baeea878",
  null
  
)

export default component.exports